<template>
  <div>
    <b-row>
      <b-col sm="12" md="12" v-if="checkAccessPrivilege('JeetPrivilege.Cashback.Query')">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-calendar'></i> Period</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="searchDate">Cashback Date:</label>
              <b-input id="searchDate" type="date" placeholder="" v-model="searchDate" :state="$v.searchDate.$error?false:null" @blur.native="$v.searchDate.$touch"></b-input>
              <div v-if="$v.searchDate.$error">
                <div class="invalid-feedback d-block" v-if="!$v.searchDate.required">&nbsp;&nbsp; Required &nbsp;&nbsp;</div>
              </div>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="username">Username </label>
              <b-input id="username" type="text" placeholder="" v-model="username" :state="$v.username.$error?false:null" @blur.native="$v.username.$touch"></b-input>
              <div v-if="$v.username.$error">
                <div class="invalid-feedback d-block" v-if="!$v.username.minLength">&nbsp;&nbsp; Username should be 1 to 5 character &nbsp;&nbsp;</div>
                <div class="invalid-feedback d-block" v-if="!$v.username.maxLength">&nbsp;&nbsp; Username should be 1 to 5 character &nbsp;&nbsp;</div>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="query" :disabled="$v.searchDate.$invalid || $v.username.$invalid"><i class="fa fa-search"></i> Query</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-inr'></i> Cashback Report</h3>
              <h5 class="float-right" style="margin-left: 10px"> Total Cashback: {{format(totalCashback, '0,0.00')}}</h5>
              <b-button class="float-right" variant="primary" @click="exportCSV" :disabled="items.length === 0" v-if="checkAccessPrivilege('JeetPrivilege.Cashback.Export')">Export</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(SlotLosing)="data">
                <span>{{format(data.item.SlotLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(SlotPromoLosing)="data">
                <span>{{format(data.item.SlotPromoLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(LiveLosing)="data">
                <span>{{format(data.item.LiveLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(LivePromoLosing)="data">
                <span>{{format(data.item.LivePromoLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(OtherLosing)="data">
                <span>{{format(data.item.OtherLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(OtherPromoLosing)="data">
                <span>{{format(data.item.OtherPromoLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(TotalLosing)="data">
                <span>{{format(data.item.TotalLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(TotalPromoLosing)="data">
                <span>{{format(data.item.TotalPromoLosing, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(SlotCashback)="data">
                <span>{{format(data.item.SlotCashback, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(LiveCashback)="data">
                <span>{{format(data.item.LiveCashback, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(OtherCashback)="data">
                <span>{{format(data.item.OtherCashback, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(TotalCashback)="data">
                <span>{{format(data.item.TotalCashback, '0,0.00')}}</span>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import numeral from 'numeral'
  import moment from 'moment-timezone'
  import {Events} from '../../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'cashback-report-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'MemberId', label: 'Member ID'},
          {key: 'Username', label: 'Username'},
          {key: 'SlotLosing', label: 'Slot Losing'},
          {key: 'SlotPromoLosing', label: 'Slot Promo. Losing'},
          {key: 'LiveLosing', label: 'Live Losing'},
          {key: 'LivePromoLosing', label: 'Live Promo. Losing'},
          {key: 'OtherLosing', label: 'Other Losing'},
          {key: 'OtherPromoLosing', label: 'Other Promo. Losing'},
          {key: 'TotalLosing', label: 'Total Losing'},
          {key: 'TotalPromoLosing', label: 'Total Promo. Losing'},
          {key: 'SlotCashback', label: 'Slot Cashback'},
          {key: 'LiveCashback', label: 'Live Cashback'},
          {key: 'OtherCashback', label: 'Other Cashback'},
          {key: 'TotalCashback', label: 'Total Cashback'}
        ],
        currentPage: 1,
        perPage: 20,
        totalCashback: 0,
        searchDate: '',
        username: ''
      }
    },
    validations: {
      searchDate: { required },
      username: { minLength: minLength(1), maxLength: maxLength(50) }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      exportCSV () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashback/csv', {searchDate: this.searchDate, username: this.username}, {responseType: 'blob', headers: { 'Content-Type': 'application/json' }}).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `cashback_${moment(this.searchDate).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getRowCount (items) {
        return items.length
      },
      query () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashback', {searchDate: this.searchDate, username: this.username}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
          this.totalCashback = response.data.totalCashback
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/cashbackReport/CashbackReportTable.vue